import { SafeAreaView } from "./layouts/SafeArea";
import RootNavigator from "./screens/RootNavigator";

export function App() {
    return (
        <div>
            <SafeAreaView>
                <SafeAreaView>
                    <RootNavigator />
                </SafeAreaView>
            </SafeAreaView>
        </div>
    );
}
